module.exports = __webpack_public_path__ + "fonts/iconfont.891b8722.ttf";